<template>
  <v-container
      id="service-card"
      fluid
      tag="section"
      pt-0
  >
    <v-row class="mt-1" justify="center">
      <v-col cols="12" :md="!onlyCreate ? 5 : 12" class="pt-3">
        <base-material-card>
          <template v-slot:heading>
            <div class="subtitle-1 font-weight-light d-flex">
              <div>
                <v-tooltip
                    v-model="copyLinkSuccess"
                    right
                    internal-activator
                    :open-on-hover="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                                    <span @click="copyLink" v-bind="attrs"
                                          v-on="on">{{ formTitle }}</span>
                  </template>
                  {{ $vuetify.lang.t('$vuetify.page.action.copyLinkSuccess') }}
                </v-tooltip>
              </div>
              <v-spacer/>
              <template v-if="!editMode">
                <v-btn
                    color="red lighten-2"
                    x-small
                    depressed
                    @click="deleteItem"
                    class="mr-3"
                >
                  {{ $vuetify.lang.t('$vuetify.page.action.btnDelete') }}
                </v-btn>
                <v-btn
                    color="indigo"
                    x-small
                    depressed
                    @click="edit"
                >
                  {{ $vuetify.lang.t('$vuetify.page.action.btnEdit') }}
                </v-btn>

                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="headline">
                      {{ $vuetify.lang.t('$vuetify.page.all.deleteMsg') }}
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">
                        {{ $vuetify.lang.t('$vuetify.page.action.btnCancel') }}
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                             :loading="axiosLoading">
                        {{ $vuetify.lang.t('$vuetify.page.action.btnYes') }}
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
            </div>
          </template>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              v-if="editMode"
              class="mt-2"
          >
            <v-container>
              <v-row>
                <v-col
                    cols="8"
                >
                  <v-autocomplete
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.clientName')"
                      :items="clientUserDictList"
                      item-text="name"
                      item-value="id"
                      v-model="currentService.client.id"
                      :rules="[fieldValidationRules.required(vue)]"
                      hide-details="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col
                    cols="4"
                >
                  <v-select
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceImportance')"
                      :items="serviceImportanceDictList"
                      item-text="name"
                      item-value="id"
                      v-model="currentService.serviceImportance.id"
                      :rules="[fieldValidationRules.required(vue)]"
                      hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="6"
                >
                  <v-datetime-picker
                      no-title
                      v-model="currentService.serviceDate"
                      date-format="yyyy-MM-dd"
                      time-format="HH:mm"
                      :label="$vuetify.lang.t(`$vuetify.page.ServicesCard.serviceDate`)"
                      :time-picker-props="timeProps"
                      :date-picker-props="dateProps"
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar-blank</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-calendar-clock</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      :disabled="!currentService.client.id"
                      dense
                      outlined
                      ref="clientPhone"
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.clientPhone')"
                      v-model="currentService.clientPhone"
                      hide-details="auto"
                      v-mask="'+7 (###) ###-##-##'"
                      class="mt-3"
                      append-icon="mdi-account-search-outline"
                      @click:append="searchContact"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12"
                    md="4"
                >
                  <v-select
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.department')"
                      :items="departmentDictList"
                      item-text="name"
                      item-value="id"
                      v-model="currentService.department.id"
                      :rules="[fieldValidationRules.required(vue)]"
                      hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                >
                  <v-select
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceType')"
                      :items="serviceTypeDictList"
                      item-text="name"
                      item-value="id"
                      v-model="currentService.serviceType.id"
                      :rules="[fieldValidationRules.required(vue)]"
                      hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                >
                  <v-select
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceVisitType')"
                      :items="serviceVisitTypeDictList"
                      item-text="name"
                      item-value="id"
                      v-model="currentService.serviceVisitType.id"
                      :rules="[fieldValidationRules.required(vue)]"
                      hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12">
                  <v-text-field
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceTypeDescription')"
                      v-model="currentService.serviceTypeDescription"
                      hide-details="auto"
                      counter="64"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                    cols="12">
                  <v-textarea
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.description')"
                      v-model="currentService.description"
                      :rules="[fieldValidationRules.required(vue)]"
                      hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="!isNew">
                <v-col
                    cols="12">
                  <v-textarea
                      dense
                      outlined
                      :label="$vuetify.lang.t('$vuetify.page.ServicesCard.solution')"
                      v-model="currentService.solution"
                      hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="onlyCreate">
                <v-col
                    cols="12">
                  <v-checkbox
                      label="Перейти в услугу после сохранения"
                      v-model="goToService"
                      hide-details="auto"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <div class="mt-2" v-else-if="currentService">
            <v-row>
              <v-col
                  cols="12">
                <v-select
                    dense
                    outlined
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.status')"
                    v-model="currentService.serviceStatus.id"
                    :items="serviceStatusDictList"
                    item-text="name"
                    item-value="id"
                    v-on:change="changeStatus"
                    hide-details="auto"
                >
                </v-select>
                <service-executor-panel
                    :service-id="serviceId"
                    :can-add="true"
                ></service-executor-panel>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                  cols="8"
              >
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.clientName')"
                    v-model="clientName"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                    append-outer-icon="mdi-card-account-details-outline"
                    @click:append-outer="showClientCard"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="4"
              >
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceImportance')"
                    v-model="currentService.serviceImportance.name"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  cols="6"
              >
                <v-text-field
                    v-model="currentService.serviceDate"
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceDate')"
                    readonly
                    outlined
                    dense
                    hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="6"
              >
                <v-text-field
                    v-model="currentService.clientPhone"
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.clientPhone')"
                    readonly
                    outlined
                    dense
                    hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  cols="4"
              >
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.department')"
                    v-model="currentService.department.name"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="4"
              >
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceType')"
                    v-model="currentService.serviceType.name"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="4"
              >
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceVisitType')"
                    v-model="serviceVisitTypeName"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  cols="12">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.serviceTypeDescription')"
                    v-model="currentService.serviceTypeDescription"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  cols="12">
                <v-textarea
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.description')"
                    v-model="currentService.description"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  cols="12">
                <v-textarea
                    :label="$vuetify.lang.t('$vuetify.page.ServicesCard.solution')"
                    v-model="currentService.solution"
                    dense
                    readonly
                    outlined
                    hide-details="auto"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>

          <template v-slot:actions v-if="editMode">
            <v-btn
                color="red darken-1"
                text
                small
                @click="cancel"
                v-if="!onlyCreate"
            >
              {{ $vuetify.lang.t('$vuetify.page.action.btnCancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                small
                @click="save"
                :loading="axiosLoading" :disabled="!valid"
            >
              {{ $vuetify.lang.t('$vuetify.page.action.btnSave') }}
            </v-btn>
          </template>
        </base-material-card>
      </v-col>
      <v-col cols="12" md="7" v-if="currentService && !onlyCreate">
        <chat-panel></chat-panel>
        <chat-multi-media-show></chat-multi-media-show>
      </v-col>
    </v-row>
    <v-dialog
        v-model="searchContactDialog"
        max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $vuetify.lang.t('$vuetify.page.ServicesCard.clientContact') }}</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="contact in clientContactList" :key="contact.id"
                         @click="selectClientNumber(contact.user.phone)">{{ contact.user.displayName }}
              ({{ contact.user.phone }})
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ServiceExecutorPanel from "@/view/dashboard/components/service/ServiceExecutorPanel";
import ChatPanel from "@/view/dashboard/components/chat/ChatPanel";
import {mask} from 'vue-the-mask'

export default {
  name: "ServiceCard",
  directives: {mask},
  components: {
    ChatPanel,
    ServiceExecutorPanel,
    ChatMultiMediaShow: () => import('@/view/dashboard/components/chat/ChatMultiMediaShow'),
  },
  props: {
    serviceId: String,
    onlyCreate: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.isNew) {
      this.$store.dispatch('retrieveService', null)
      if (!this.onlyCreate) {
        this.$store.dispatch('retrieveChat', null)
      }
      this.setService(this.defaultService)
      this.editMode = true
    } else {
      this.$store.dispatch('retrieveService', this.serviceId).then((data) => {
        this.setService(data)
      })
    }
    this.$store.dispatch('retrieveClientDictionaryList')
    this.$store.dispatch('retrieveDepartmentDictionaryList')
    this.$store.dispatch('retrieveServiceTypeDictionaryList')
    this.$store.dispatch('retrieveServiceStatusDictionaryList')
    this.$store.dispatch('retrieveServiceImportanceDictList')
    this.$store.dispatch('retrieveServiceVisitTypeDictList').then(() => {
      this.setDefaultValues()
    })
  },
  beforeDestroy: function () {
    this.$store.dispatch('leaveGroup').then(() =>
        this.$store.dispatch('retrieveChat', null)
    )
  },
  watch: {
    'currentService.executors': {
      handler() {
        if (this.currentService.activities) {
          this.$store.dispatch('retrieveChatAttendees', this.currentService.activities[0].id)
        }
      }
    }
  },
  computed: {
    isNew() {
      return this.serviceId === '00000000-0000-0000-0000-000000000000'
    },
    formTitle() {
      return this.$store.getters.currentService ? this.$store.getters.currentService.number : ''
    },
    clientUserDictList() {
      return this.$store.getters.clientDictionaryList
    },
    departmentDictList() {
      return this.$store.getters.departmentDictionaryList
    },
    serviceTypeDictList() {
      return this.$store.getters.serviceTypeDictionaryList
    },
    serviceImportanceDictList() {
      return this.$store.getters.serviceImportanceDictionaryList
    },
    serviceStatusDictList() {
      return this.$store.getters.serviceStatusDictionaryList
    },
    serviceVisitTypeDictList() {
      return this.$store.getters.serviceVisitTypeDictList
    },
    clientName() {
      return this.currentService.client ? this.currentService.client.name : null
    },
    serviceVisitTypeName() {
      return this.currentService.serviceVisitType ? this.currentService.serviceVisitType.name : null
    },
    chatCreateServiceMessageList() {
      return this.$store.getters.chatCreateServiceMessageList
    },
  },
  data() {
    return {
      goToService: false,
      currentService: null,
      searchContactDialog: false,
      clientContactList: [],
      defaultService: {
        id: null,
        client: {
          id: null,
        },
        clientPhone: null,
        solution: null,
        number: '-',
        department: {
          id: null,
        },
        serviceType: {
          id: null,
        },
        serviceVisitType: {
          id: null,
        },
        serviceTypeDescription: null,
        serviceImportance: {
          id: null,
        },
        description: null,
        externalNumber: null,
        executors: [],
        serviceDate: this.moment().format(this.moment().defaultFormatUtc)
      },
      valid: !this.formError,
      vue: this,
      editMode: false,
      dialogDelete: false,
      copyLinkSuccess: false,
      serviceDateMenu: false,
      timeProps: {
        useSeconds: false,
        ampmInTitle: false,
        format: '24hr'
      },
      dateProps: {
        noTitle: true,
        locale: "ru-ru",
        firstDayOfWeek: "1"
      },
    }
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        if (!this.currentService.id) {
          this.currentService.id = this.$uuid.v4()
          this.currentService.serviceDate = this.moment(this.currentService.serviceDate).format(this.moment().defaultFormatUtc)

          if (this.chatCreateServiceMessageList.length > 0) {
            this.currentService.commentToWorkIds = this.chatCreateServiceMessageList
          }

          this.$store.dispatch('createService', this.currentService).then(() => {
            let serviceId = this.currentService.id

            this.$store.dispatch('clearChatCreateService')
            window.VueEvent.fire('clear-all-chat-create-service')

            if (this.onlyCreate) {
              if (this.goToService) {
                this.goToServiceCard(serviceId, false)
              } else {
                this.setService(this.defaultService)
                this.$store.dispatch('retrieveService', null)
                window.VueEvent.fire('clear-create-service-message')
              }
            } else {
              this.goToServiceCard(serviceId, true)
            }
          }).catch(() => this.currentService.id = null)
        } else {
          this.currentService.serviceDate = this.moment(this.currentService.serviceDate).format(this.moment().defaultFormatUtc)
          this.$store.dispatch('storeService', this.currentService).then((data) => {
            this.setService(data)
            this.editMode = false
          })
        }
      }
    },
    goToServiceCard(serviceId, refreshPage) {
      this.$router.push({
        name: 'ServicesCard',
        params: {serviceId}
      })
      if (refreshPage) {
        this.$router.go(0)
      }
    },
    edit() {
      this.editMode = true
      this.setDefaultValues()
    },
    setService(data) {
      this.currentService = JSON.parse(JSON.stringify(data))

      if (this.currentService.serviceDate) {
        this.currentService.serviceDate = this.moment(this.currentService.serviceDate).format('YYYY-MM-DD HH:mm')
      }

      if (!this.currentService.client) {
        this.currentService.client = {
          id: null,
          name: null
        }
      }
      if (!this.currentService.serviceVisitType) {
        this.currentService.serviceVisitType = {
          id: null,
          name: null
        }
      }

      if (this.currentService.activities) {
        this.$store.dispatch('retrieveChat', {
          chatId: this.currentService.activities[0].id,
          commentLimit: 20
        })
      }
    },
    cancel() {
      if (this.isNew) {
        this.$router.push({name: 'Services'})
      } else {
        this.$store.dispatch('retrieveService', this.currentService.id).then((data) =>
            this.setService(data)
        )
        this.editMode = false

      }
    },
    changeStatus() {
      this.$store.dispatch('changeServiceStatus', {
        serviceId: this.currentService.id,
        statusId: this.currentService.serviceStatus.id
      })
    },
    deleteItem() {
      this.dialogDelete = true
    },
    deleteItemConfirm() {
      this.$store.dispatch('deleteService', this.currentService.id).then(() =>
          this.$router.push({name: 'Services'})
      )
    },
    closeDelete() {
      this.dialogDelete = false
    },
    showClientCard() {
      if (!this.currentService.client) {
        return
      }
      let clientId = this.currentService.client.id
      let routeData = this.$router.resolve({
        name: 'ClientsCard',
        params: {clientId}
      });
      window.open(routeData.href, '_blank');
    },
    copyLink() {
      this.copyToClipboard(window.location.href)
      this.copyLinkSuccess = true
      setTimeout(() => {
        this.copyLinkSuccess = false
      }, 2000);
    },
    setDefaultValues() {
      if (!this.currentService) {
        return
      }

      if (!this.currentService.serviceVisitType.id) {
        if (this.serviceVisitTypeDictList.length > 0) {
          this.currentService.serviceVisitType = this.serviceVisitTypeDictList[0]
        }
      }
    },
    searchContact() {
      this.$store.dispatch('retrieveClientContactById', {id: this.currentService.client.id}).then((response) => {
        this.clientContactList = response
        this.searchContactDialog = true
      })
    },
    selectClientNumber(number) {
      this.searchContactDialog = false
      this.currentService.clientPhone = number
      this.$refs.clientPhone.validate();
    }
  }
}
</script>

<style scoped>

</style>